<!-- src/components/Feed.vue -->
<template>
    <v-container id="feed">
        <v-row>
            <v-col cols="12" :md="fullWidth ? 12 : 3" offset-md="1" v-if="checkDisplay">
                <v-row no-gutters>

                    <v-col cols="12">
                        <CommunityList @select="selectCommunity" 
                            :communities="isUserAdminOrSU ? availableCommunities : userCommunities"
                            :isUserAdminOrSU="isUserAdminOrSU" :load_status="loading"
                            :selected="selectedCommunity" @update="updateCommunity" @delete="deleteCommunity"
                            @create="createCommunity" ref="communityList" />
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" :md="fullWidth ? 12 : 5" :offset-md="checkDisplay ? 0 : 3" class="px-0">

                <!-- Page content -->
                <v-row no-gutters v-if="!loading" >


                    <v-col cols="12" >
                        <v-toolbar class="rounded-lg elevation-0 mb-4 mx-4" v-if="availableCommunities.length > 1">
                            <v-list-item two-line class="px-0">
                                <v-list-item-avatar color="primary lighten-4" class="mr-3">
                                    <v-icon color="primary">
                                        {{ selectedCommunity === 'general' ? 'mdi-earth' :
                                            'mdi-account-group' }}
                                    </v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title class="text-h6">
                                        {{availableCommunities.find(c => c.id === selectedCommunity)?.name || "General"
                                        }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle class="d-flex align-center" 
                                        v-if="selectedCommunity != 'general' && !availableCommunities.find(c => c.id === selectedCommunity)?.isPublic ">

                                        <v-icon small class="mr-1">mdi-account-multiple</v-icon>
                                        {{availableCommunities.find(c => c.id === selectedCommunity)?.members?.length
                                            || 0}} {{
                                            availableCommunities.find(c => c.id === selectedCommunity)?.members?.length == 1
                                                ? 'Miembro' :
                                                'Miembros'}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-spacer />

                            <v-tooltip bottom>
                                <template #activator="{ on }">
                                    <v-btn icon  @click="editCommunity" v-on="on"
                                        class="mr-2">
                                        <v-icon>mdi-cog</v-icon>
                                    </v-btn>
                                </template>
                                <span>Editar Comunidad</span>
                            </v-tooltip>
                        </v-toolbar>

                        <PostForm class="mx-4 mb-4" v-if="isUserAdminOrSU" :availableCommunities="availableCommunities"
                            @create="createPost" :selectedCommunity="selectedCommunity" />
                    </v-col>

                    <v-col cols="12">
                        <v-row no-gutters>
                            <v-col cols="12"  v-for="post in sortedPosts" :key="post.id">
                                <PostForm :selectedCommunity="selectedCommunity" class="mx-4"
                                    v-if="selectedPost && selectedPost.id === post.id" :value="selectedPost"
                                    :availableCommunities="availableCommunities" @update="updatePost"
                                    @cancelEdit="cancelEdit" />

                                <PostDisplay :key="post.id + 'display'" v-if="
                                    !selectedPost ||
                                    (selectedPost && selectedPost.id !== post.id)
                                " :value="post" @openEdit="selectedPost = { ...post }" @update="updatePost"
                                    @delete="deletePost" />
                            </v-col>
                            <v-col cols="12" class="text-center" v-if="hasMorePosts && !loadingMore">
                                <v-btn text color="primary" @click="loadMorePosts" class="my-4">
                                    <v-icon left>mdi-refresh</v-icon>
                                    Cargar más publicaciones
                                </v-btn>
                            </v-col>
                            <v-col cols="12" class="text-center my-4" v-if="loadingMore">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <!-- Skeletons -->
                <v-scroll-x-transition hide-on-leave mode="in-out">
                    <div v-show="loading"  class="mx-4"  >
                        <v-skeleton-loader class="mb-4" type="article,actions" />
                        <v-skeleton-loader class="mb-4" type="article,actions" />
                        <v-skeleton-loader class="mb-4" type="article,actions" />
                    </div>

                </v-scroll-x-transition>

                <!-- Empty page -->
                <v-scroll-x-transition hide-on-leave mode="in-out">


                    <!--   <v-img
        src="@/assets/posts.svg"
        height="200px"
        class="white--text align-end rounded overflow-hidden"
        gradient="to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.7)"
      >
       
      </v-img> -->



                    <v-card color="transparent" class="py-10 pb-2 text-center rounded-lg" elevation="0" v-show="!loading && !posts.length" style="width: min(470px, 100vw); margin: 0 auto;">
                        <v-img src="@/assets/alert.svg" max-height="200" contain class="mb-6"></v-img>
                        <v-card-text>
                            <h2 class="text-h5 mb-2">No hay publicaciones</h2>
                            <p class="text-body-1 text-medium-emphasis">
                                {{ isUserAdminOrSU
                                    ? "Sé el primero en crear una nueva publicación para esta comunidad"
                                    : "Aún no hay contenido disponible en esta comunidad" }}
                            </p>
                            
                        </v-card-text>
                    </v-card>

                    <!--           <v-alert type="info" color="primary" text border="left" class="mt-4" >
            {{
              isUserAdminOrSU
                ? "No hay publicaciones, crea una nueva"
                : "No hay publicaciones"
            }}
          </v-alert> -->
                </v-scroll-x-transition>
            </v-col>



        </v-row>
    </v-container>
</template>

<script>
import {
    collection,
    getDocs,
    doc,
    getDoc,
    addDoc,
    updateDoc,
    deleteDoc,
    getFirestore,
    query,
    where,
    orderBy,
    onSnapshot,
    limit,
    startAfter
} from "firebase/firestore";
import { ref as storageRef, getStorage, deleteObject } from "firebase/storage";
import PlanProgress from "@/components/PlanProgress.vue";
import PostForm from "@/components/feed/form/PostForm.vue";
import PostDisplay from "@/components/feed/post/PostDisplay.vue";
import CommunityForm from "@/components/community/CommunityForm.vue";
import CommunityList from "@/components/community/CommunityList.vue";

export default {
    props: {
        drawer2: {
            type: Boolean,
            default: false,
        },
        communityId: {
            type: String,
            default: null
        }
    },


    name: "Feed",

    components: {
        PlanProgress,
        PostForm,
        PostDisplay,
        CommunityForm,
        CommunityList,
    },

    data() {
        return {
            posts: [],
            loading: true,
            loadingMore: false,
            hasMorePosts: false,
            lastVisible: null,
            postsPerPage: 3,
            availableCommunities: [],
            userCommunities: [],
            selectedPost: null,
            selectedCommunity: 'general',
            unsubscribePosts: null,
            fullWidth: false,
            publicCommunitiesUnsubscribes: {},
            publicCommunitiesNewPosts: {},
            communitiesWithNewPosts: []
        };
    },

    async mounted() {
        // Add check for parent drawer
        if (this.$el.closest('.v-navigation-drawer')) {
            this.fullWidth = true;
        }

        // Add scroll event listener for infinite scrolling
        window.addEventListener('scroll', this.handleScroll);

        // Check if a specific community ID was provided in the route
        const routeCommunityId = this.$route.params.communityId;
        
        // Set the selected community ID
        if (routeCommunityId) {
            this.selectedCommunity = routeCommunityId;
        }
        
        // Fetch communities first
        if (this.isUserAdminOrSU) {
            await this.fetchAvailableCommunities();
        }
        await this.fetchUserCommunities();
        
        // Only load posts here if no specific community was requested
        // For specific communities, the userCommunities watcher will handle it
        if (!routeCommunityId) {
            this.loadInitialPosts('general');
        }
        
        // Subscribe to all public communities
        this.subscribeToAllPublicCommunities();

        // Check if the "Load more" button is visible on initial load
        this.$nextTick(() => {
            setTimeout(() => {
                this.checkLoadMoreButtonVisibility();
            }, 500); // Small delay to ensure DOM is fully rendered
        });
    },

    computed: {
        isUserAdminOrSU() {
            const role = this.$store.state.Auth.token.claims.type;
            return role && ["admin", "superuser","communityModerator"].includes(role);
        },
        sortedPosts() {
            return this.posts.sort((a, b) => b.created.date - a.created.date);
        },
        checkDisplay() {
            return this.isUserAdminOrSU ? true : this.userCommunities.length > 1;
        }
    },

    methods: {
        checkLoadMoreButtonVisibility() {
            if (this.hasMorePosts && !this.loadingMore && !this.loading) {
                const loadMoreBtn = document.querySelector('.v-btn.my-4');
                if (loadMoreBtn) {
                    const rect = loadMoreBtn.getBoundingClientRect();
                    // If the button is visible in the viewport, load more posts
                    if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                        this.loadMorePosts();
                    }
                }
            }
        },

        handleScroll() {
            // Check if we're near the bottom of the page
            if (this.hasMorePosts && !this.loadingMore && !this.loading) {
                const scrollHeight = document.documentElement.scrollHeight;
                const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                const clientHeight = document.documentElement.clientHeight;
                
                // If we're near the bottom (200px threshold), load more posts
                if (scrollTop + clientHeight >= scrollHeight - 200) {
                    this.loadMorePosts();
                }
            }
        },

        loadInitialPosts(communityId) {
            this.loading = true;
            this.posts = [];
            this.lastVisible = null;
            this.hasMorePosts = false;
            
            const db = getFirestore();
            const postsRef = collection(db, "posts");
            const q = query(
                postsRef,
                where("communityId", "==", communityId),
                orderBy("created.date", "desc"),
                limit(this.postsPerPage)
            );

            this.unsubscribePosts = onSnapshot(q, (snapshot) => {
                // Update posts
                if (!snapshot.empty) {
                    // Get posts data
                    let posts = snapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));

                    // Add communityName to each post
                    posts = posts.map((post) => ({
                        ...post,
                        communityName:
                            this.userCommunities.find((c) => c.id === post.communityId)?.name ||
                            "General",
                    }));

                    this.posts = posts;
                    
                    // Store last document for pagination
                    this.lastVisible = snapshot.docs[snapshot.docs.length - 1];
                    
                    // Check if there might be more posts
                    this.hasMorePosts = snapshot.docs.length === this.postsPerPage;
                } else {
                    this.posts = [];
                    this.hasMorePosts = false;
                }
                
                this.loading = false;

                // Check if the "Load more" button is visible now that posts are loaded
                this.$nextTick(() => {
                    this.checkLoadMoreButtonVisibility();
                });

               /*  // Calculate unread posts when feed is not visible
                if (!this.$props.drawer2) {
                    const lastCheck = this.$store.state.lastPostCheck / 1000 || 0;
                    const newPosts = posts.filter(post =>
                        post.created.date.seconds > lastCheck
                    ).length;
                    this.$emit('update-unread', newPosts);
                } */
            });
        },

        async loadMorePosts() {
            if (!this.lastVisible || this.loadingMore) return;
            
            this.loadingMore = true;
            
            const db = getFirestore();
            const postsRef = collection(db, "posts");
            const q = query(
                postsRef,
                where("communityId", "==", this.selectedCommunity),
                orderBy("created.date", "desc"),
                startAfter(this.lastVisible),
                limit(this.postsPerPage)
            );
            
            try {
                const snapshot = await getDocs(q);
                
                if (!snapshot.empty) {
                    // Get new posts
                    let newPosts = snapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    
                    // Add communityName to each post
                    newPosts = newPosts.map((post) => ({
                        ...post,
                        communityName:
                            this.userCommunities.find((c) => c.id === post.communityId)?.name ||
                            "General",
                    }));
                    
                    // Append to existing posts
                    this.posts = [...this.posts, ...newPosts];
                    
                    // Update last visible
                    this.lastVisible = snapshot.docs[snapshot.docs.length - 1];
                    
                    // Check if there might be more posts
                    this.hasMorePosts = snapshot.docs.length === this.postsPerPage;
                } else {
                    this.hasMorePosts = false;
                }
            } catch (error) {
                console.error("Error loading more posts:", error);
                this.$notify({
                    title: "Error",
                    text: "No se pudieron cargar más publicaciones",
                    type: "error"
                });
            }
            
            this.loadingMore = false;
        },

        subscribeToNewPosts(communityId) {
            if (this.unsubscribePosts) {
                this.unsubscribePosts();
            }
            
            // Reset posts and load initial batch
            this.loadInitialPosts(communityId);
        },

        async fetchAvailableCommunities() {
            const db = getFirestore();
            const querySnapshot = await getDocs(collection(db, "communities"));
            let communities = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));


            //check if general community exists and add it if it doesn't
            if (!communities.find((c) => c.id === "general")) {
                communities.unshift({ id: "general", name: "General", isPublic: true });
            }

            // Sort communities: first public communities, then private ones
            communities.sort((a, b) => {
                // General community always comes first
                if (a.id === 'general') return -1;
                if (b.id === 'general') return 1;
                
                // Then sort by public status (public ones first)
                if (a.isPublic && !b.isPublic) return -1;
                if (!a.isPublic && b.isPublic) return 1;
                
                // Finally sort alphabetically by name
                return a.name.localeCompare(b.name);
            });

            this.availableCommunities = communities;
        },

        async fetchUserCommunities() {
            const db = getFirestore();
            const userId = this.$store.state.Auth.token.claims.user_id;
            const userDoc = await getDoc(doc(db, "users", userId));
            const userData = userDoc.data();

            let userCommunityIds = userData.enabledCommunities || [];

            // Always include 'general' community
            if (!userCommunityIds.includes("general")) {
                userCommunityIds.unshift("general");
            }

            // Get all communities to check for public ones
            const communitiesSnapshot = await getDocs(collection(db, "communities"));
            
            // Fetch community details
            let communities = [];
            // Add general community first
            communities.push({ id: "general", name: "General", isPublic: true });
            
            // Add all public communities and user's communities
            for (const communityDoc of communitiesSnapshot.docs) {
                const communityData = communityDoc.data();
                // Include if it's a public community or in user's enabled communities
                if (communityData.isPublic || userCommunityIds.includes(communityDoc.id)) {
                    communities.push({
                        id: communityDoc.id,
                        ...communityData
                    });
                }
            }

            // Sort communities: first public communities, then private ones
            communities.sort((a, b) => {
                // General community always comes first
                if (a.id === 'general') return -1;
                if (b.id === 'general') return 1;
                
                // Then sort by public status (public ones first)
                if (a.isPublic && !b.isPublic) return -1;
                if (!a.isPublic && b.isPublic) return 1;
                
                // Finally sort alphabetically by name
                return a.name.localeCompare(b.name);
            });

            this.userCommunities = communities;
        },

        createPost(post) {
            // Ensure the post already has the displayName
            //this.posts.unshift(post);
        },

        updatePost(post) {
            const postIndex = this.posts.findIndex((e) => e.id === post.id);
            if (postIndex !== -1) {
                this.$set(this.posts, postIndex, post);
            }

            if (this.selectedPost) {
                this.selectedPost = null;
            }
        },

        deletePost(post) {
            const postIndex = this.posts.findIndex((e) => e.id === post.id);
            if (postIndex !== -1) {
                this.posts.splice(postIndex, 1);
            }
        },

        cancelEdit() {
            this.selectedPost = null;
        },

        createCommunity(community) {
            this.availableCommunities.push(community);

            this.$nextTick(() => {
                this.$refs.communityList.selectCommunity(community);
            });
        },

        updateCommunity(updatedCommunity) {
            const index = this.availableCommunities.findIndex(
                (c) => c.id === updatedCommunity.id
            );
            if (index !== -1) {
                this.$set(this.availableCommunities, index, updatedCommunity);
            }
        },

        deleteCommunity(communityId) {
            const index = this.availableCommunities.findIndex(
                (c) => c.id === communityId
            );
            if (index !== -1) {
                this.availableCommunities.splice(index, 1);
            }

            //select general
            this.subscribeToNewPosts('general');
        },

        selectCommunity(community) {
            // Clean up subscription for the previously selected community
            if (this.publicCommunitiesUnsubscribes[this.selectedCommunity]) {
                // If we're leaving a public community, start tracking it in background
                if (community.id !== this.selectedCommunity && 
                    this.availableCommunities.find(c => c.id === this.selectedCommunity)?.isPublic) {
                    this.subscribeToCommunityPosts(this.selectedCommunity);
                }
            }
            
            // Update selected community
            this.selectedCommunity = community.id;
            
            // Subscribe to new selected community
            this.subscribeToNewPosts(community.id);
            
            // Reset counter for this community
            if (this.publicCommunitiesNewPosts[community.id]) {
                this.publicCommunitiesNewPosts[community.id] = 0;
                
                // Update the communities with new posts list
                this.updateCommunitiesWithNewPosts();
            }
            
            // Update the URL to reflect the selected community
            if (this.$route.params.communityId !== community.id) {
                if (community.id === 'general') {
                    // For general community, just go to the base community URL
                    this.$router.push('/comunidad');
                } else {
                    // For specific communities, include the ID in the URL
                    this.$router.push(`/comunidad/${community.id}`);
                }
            }
            
            // Reset unread count and update last check time when actively viewing posts
            if (this.$props.drawer2) {
                this.$store.dispatch("updateLastPostCheck", Date.now());
                
                // Recalculate total unread for other communities
                const totalUnread = Object.entries(this.publicCommunitiesNewPosts)
                    .filter(([id]) => id !== community.id)
                    .reduce((sum, [, count]) => sum + count, 0);
                
                this.$emit('update-unread', totalUnread);
                
                // Update communities list
                const communitiesText = this.communitiesWithNewPosts
                    .filter(name => {
                        const comm = this.userCommunities.find(c => c.name === name);
                        return comm && comm.id !== community.id;
                    })
                    .join(', ');
                    
                this.$emit('update-unread-details', communitiesText);
            }
        },

        editCommunity() {
            this.$refs.communityList.editCommunity(
                this.availableCommunities.find((c) => c.id === this.selectedCommunity)
            );
        },

        subscribeToAllPublicCommunities() {
            // First clean up any existing subscriptions
            Object.values(this.publicCommunitiesUnsubscribes).forEach(unsubscribe => {
                if (typeof unsubscribe === 'function') {
                    unsubscribe();
                }
            });
            
            this.publicCommunitiesUnsubscribes = {};
            this.publicCommunitiesNewPosts = {};
            
            // Subscribe to each public community except the currently selected one
            const publicCommunities = this.userCommunities.filter(c => c.isPublic && c.id !== this.selectedCommunity);
            
            publicCommunities.forEach(community => {
                this.subscribeToCommunityPosts(community.id);
            });
        },
        
        subscribeToCommunityPosts(communityId) {
            const db = getFirestore();
            const postsRef = collection(db, "posts");
            const q = query(
                postsRef,
                where("communityId", "==", communityId),
                orderBy("created.date", "desc"),
                limit(10)
            );
            
            // Initialize counter for this community
            this.publicCommunitiesNewPosts[communityId] = 0;
            
            // Subscribe to updates
            this.publicCommunitiesUnsubscribes[communityId] = onSnapshot(q, (snapshot) => {
                // Check for new posts since last check
                const lastCheck = this.$store.state.lastPostCheck / 1000 || 0;
                
                // Count new posts
                const newPostsCount = snapshot.docs.filter(doc => {
                    const post = doc.data();
                    return post.created?.date?.seconds > lastCheck;
                }).length;
                
                // Update the count for this community
                this.publicCommunitiesNewPosts[communityId] = newPostsCount;
                
                // Update the list of communities with new posts
                this.updateCommunitiesWithNewPosts();
            });
        },
        
        updateCommunitiesWithNewPosts() {
            // Get all communities with new posts
            this.communitiesWithNewPosts = Object.entries(this.publicCommunitiesNewPosts)
                .filter(([, count]) => count > 0)
                .map(([communityId]) => {
                    // Find community name
                    const community = this.userCommunities.find(c => c.id === communityId);
                    return community ? community.name : communityId;
                });
            
            // Calculate total unread posts across all public communities
            const totalUnread = Object.values(this.publicCommunitiesNewPosts)
                .reduce((sum, count) => sum + count, 0);
            
            // Emit total unread count to update the navbar badge
            if (!this.$props.drawer2) {
                this.$emit('update-unread', totalUnread);
                
                // Also emit the list of communities with new posts
                const communitiesText = this.communitiesWithNewPosts.join(', ');
                this.$emit('update-unread-details', communitiesText);
            }
        },
    },

    beforeDestroy() {
        // Clean up main subscription
        if (this.unsubscribePosts) {
            this.unsubscribePosts();
        }
        
        // Clean up all public community subscriptions
        Object.values(this.publicCommunitiesUnsubscribes).forEach(unsubscribe => {
            if (typeof unsubscribe === 'function') {
                unsubscribe();
            }
        });
        
        // Remove scroll event listener
        window.removeEventListener('scroll', this.handleScroll);
    },
    
    watch: {
        // Watch for route changes to update selected community
        '$route.params.communityId': {
            immediate: true,
            handler(newCommunityId) {
                if (newCommunityId) {
                    if (this.userCommunities.length > 0) {
                        // Find the community object matching the ID
                        const community = this.userCommunities.find(c => c.id === newCommunityId);
                        if (community) {
                            this.selectCommunity(community);
                        }
                    } else {
                        // Store the ID to select later when communities are loaded
                        this.selectedCommunity = newCommunityId;
                    }
                }
            }
        },
        // Watch for when communities are loaded
        userCommunities: {
            handler(newCommunities) {
                if (newCommunities.length > 0 && this.selectedCommunity) {
                    // If we have a stored community ID from the route, select it now
                    const community = newCommunities.find(c => c.id === this.selectedCommunity);
                    if (community) {
                        // Using setTimeout to ensure this happens after component updates
                        setTimeout(() => {
                            this.selectCommunity(community);
                            // Also update the CommunityList component
                            if (this.$refs.communityList) {
                                this.$refs.communityList.selectCommunity(community);
                            }
                        }, 0);
                    }
                }
            }
        }
    }
};
</script>

<style scoped>
.v-card {
    transition: transform 0.2s;
}

.v-card:hover {
    transform: translateY(-2px);
}

.v-tab {
    text-transform: none;
    font-weight: 500;
}
</style>

<style>
#feed .v-slide-group__prev {
    display: none !important;
}

#feed .v-slide-group__next {
    display: none !important;
}
</style>
